// src/lib/claudeNoteStructure.js
// Calls the /api/structure-note Vercel serverless function.
// The Anthropic API key lives server-side only — never exposed to the browser.

export async function structureCallNote(rawNote) {
  if (!rawNote?.trim()) return null
  try {
    const res = await fetch('/api/structure-note', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ note: rawNote }),
    })
    if (!res.ok) throw new Error(`HTTP ${res.status}`)
    return await res.json()
  } catch (e) {
    console.error('Claude note structuring failed:', e)
    return null
  }
}
